<div class="new-strategy-container">
  @if (preloaders.editDataFetching) {
    <div class="edit-preloader">
      <libero-preload-spinner></libero-preload-spinner>
    </div>
  } @else {
    <div class="content">
      <div class="header">
        @if (!editId) {
          {{ 'strategies.strategyAdjustment' | translate }}
        } @else {
          {{ 'global.strategy' | translate }} "{{ editStrategyName }}"
        }
      </div>
      <div class="desktop-aligment">
        @if (modelStrategy) {
          <div class="btn-desc-container">
            <libero-button
              label="{{ 'strategies.strategyDescription' | translate }}"
              btnClasses="btn--icon"
              svgIcon="chevron-down"
              [svgClass]="strategyDescriptionVisible ? {'transform': 'rotate(180deg)'} : {}"
              [iconWidth]="18"
              (click)="toggleDescription()"
            ></libero-button>
          </div>
        }
        <div class="desktop-consult-btn-container">
          <libero-button
            label="{{ 'global.buttons.consultation' | translate }}"
            btnClasses="btn--icon-text icon--secondary"
            svgIcon="accountant"
            (click)="modalService.openConsultModal();"
          ></libero-button>
        </div>
      </div>
      @if (strategyDescriptionVisible) {
        <div class="description">
          @if (modelStrategyApiData && modelStrategyApiData.description) {
            {{ modelStrategyApiData.description }}
          } @else {
            {{ 'strategies.newStrategyDescription' | translate }}
          }
        </div>
      }
      <div class="desktop-aligment-weights">
        @if (!preloaders.instruments) {
          <div class="instrument-cards-container desktop-content">
            <div class="chart-header">
              {{ 'newPortfolio.strategyContent' | translate }}
            </div>
            <libero-instrument-chart-carousel
              [instrumentChart]="instrumentChart"
            ></libero-instrument-chart-carousel>
          </div>
        } @else {
          <div class="instrument-preload-container desktop-content">
            <libero-preload-spinner></libero-preload-spinner>
          </div>
        }
        <div class="instruments-container">
          <div class="instruments-header">
            {{ 'strategies.instrumentsHeader' | translate }}
          </div>
          <div class="instruments-weights">
            <div class="instruments-headings">
              <div>
                {{ 'strategies.colLabelInstrument' | translate }}
              </div>
              <div>
                {{ 'strategies.colLabelWeight' | translate }}
              </div>
            </div>
            @if (!preloaders.modelStrategy) {
              @if (instruments) {
                <div class="instruments-form">
                  @for (instrument of instruments; track instrument) {
                    @if (getInstrumentControl(instrument.instrumentId) && !instrument.cash) {
                      <div class="input-container" >
                        <libero-strategy-instrument-dropdown-input
                          [instrument]="instrument"
                          [formName]="getInstrumentControl(instrument.instrumentId)!"
                          [min]="editingEfektika ? singleEfektikaInstrumentWeight : minInstrumentThreshold"
                          [max]="getInstrumentMax(instrument)"
                          data-cy="edit-instrument-weight-row"
                          [minDisabledTooltip]="editingEfektika ? 'efektikaInstrumentLimit' : ''"
                          [maxDisabledTooltip]="editingEfektika ? 'efektikaInstrumentLimit' : hasInstrumentRemovableOrNonInsertableReachedMax(instrument) ? 'cannotIncreaseWeight' : ''"
                          [trackMaxForDisabledTooltip]="!!editId && isInstrumentRemovableOrNonInsertable(instrument)"
                          [disabledTextInput]="editingEfektika"
                        ></libero-strategy-instrument-dropdown-input>
                      </div>
                    }
                  }
                  @if (cashControl()) {
                    <div class="input-container">
                      <libero-strategy-instrument-dropdown-input
                        [min]="minCashThreshold"
                        [max]="editingEfektika ? efektikaCashMax : 100"
                        [formName]="cashControl()!"
                        [instrument]="cashInstrumentDetail()"
                        [cash]="true"
                        [maxDisabledTooltip]="editingEfektika ? 'maxEfektikaCash' : ''"
                        [minDisabledTooltip]="minCashThreshold === (strategyLimits ? (strategyLimits.minCashThreshold * 100) : null) ? 'minCashButtonDisableText' : 'minRealEstateCashButtonDisableText'"
                        data-cy="cash-strategy-instrument-dropdown-input"
                        [disabledTextInput]="editingEfektika"
                      ></libero-strategy-instrument-dropdown-input>
                    </div>
                  }
                  @if (cashControl()?.value.value < minCashThreshold) {
                    <div class="cash-error" data-cy="cash-additional-error">
                      {{ 'strategies.cashTooLowErrorPt1' | translate }}
                      {{ minCashThreshold }}
                      {{ 'strategies.cashTooLowErrorPt2' | translate }}
                    </div>
                  }
                </div>
              }
            } @else {
              <div class="preloader-container">
                <libero-preload-spinner></libero-preload-spinner>
              </div>
            }
            <div class="instruments-summary position-relative" #strategyChecksum>
              <div class="summary-label">
                {{ 'strategies.checksum' | translate }}
              </div>
              <div class="summary-sum">
                <libero-instruments-checksum-input
                  [actualValue]="actualInstrumentsSum"
                ></libero-instruments-checksum-input>
              </div>
              @if (checksumValidMessages['checksumNot100']) {
                <div class="invalid-tooltip not-100">
                  {{ 'strategies.checksumNot100' | translate }}
                </div>
              }
              @if (checksumValidMessages['instrumentsWith0']) {
                <div class="invalid-tooltip instruments-0">
                  {{ 'strategies.instrumentsWith0' | translate }}
                </div>
              }
            </div>
          </div>
          <div class="lock-button-container">
            <libero-button
              label="{{ 'strategies.updateStrategyContent' | translate }}"
              [btnClasses]="'btn--icon' + (loadingForInstrumentsEdit ? ' instruments-edit-link--loading' : '')"
              svgIcon="lock-unlocked"
              [iconWidth]="18"
              [routerLink]="[editId ? ('/strategy/edit/' + editId + '/edit-instruments' ) : '/strategy/new/edit-instruments', { editOrigin: editStrategyOrigin }]"
              [preloader]="userService.loggedUser?.managementType === 'PORTFOLIO_MANAGEMENT' && loadingForInstrumentsEdit"
              (click)="loadInstrumentsEditForPMWithStrategies()"
              [preloaderInverse]="false"
              [smallSecondary]="true"
              [buttonDisabled]="editingEfektika"
              disabledTooltipText="efektikaCannotChangeInstruments"
              data-cy="strategy-instruments-pick-btn"
            ></libero-button>
          </div>
          @if (!preloaders.instruments) {
            <div class="instrument-cards-container phone-content">
              <div class="chart-header">
                {{ 'newPortfolio.strategyContent' | translate }}
              </div>
              <libero-instrument-chart-carousel
                [instrumentChart]="instrumentChart"
              ></libero-instrument-chart-carousel>
            </div>
          } @else {
            <div class="instrument-preload-container phone-content">
              <libero-preload-spinner></libero-preload-spinner>
            </div>
          }
        </div>
      </div>
      <div class="form-background">
        <div class="form-rounding">
        </div>
      </div>
      <div class="form-header">
        @if (!editId) {
          {{ 'strategies.formHeader' | translate}}
        } @else {
          {{ 'strategies.editFormHeader' | translate }}
        }
      </div>
      <div class="form-container" [ngClass]="{'form-container--highlighted': editId}">
        @if (modelChartForm) {
          <div class="row">
            <div class="col-12 col-md-6 order-md-1 " [ngClass]="{'offset-md-3': hideDipSwitch && !editId}">
              <div class="filtration-label">
                {{ 'strategies.name' | translate }}
              </div>
              <libero-text-input
                [formName]="modelChartForm.controls['name']"
                placeholder="{{ 'strategies.newStrategyPlaceholder' | translate }}"
                data-cy="new-strategy-name-input"
                #nameInputComponent
              ></libero-text-input>
            </div>
            @if (editId) {
              <div class="col-12 col-md-6 order-md-2">
                <div class="filtration-label filtration-label--tooltiped">
                  {{ 'newPortfolio.filters.dip' | translate }}
                  <libero-tooltip-button>
                    {{ 'global.tooltips.dipNewStrategy' | translate }}
                  </libero-tooltip-button>
                </div>
                <div class="dip-switch-container --not-allowed">
                  <div class="button-readonly-container">
                    <libero-toggle-switch
                      [formName]="modelChartForm.controls['dip']"
                      [disabled]="true"
                    ></libero-toggle-switch>
                  </div>
                </div>
              </div>
            }
            @if (!hideDipSwitch && !editId) {
              <div class="col-12 col-md-6 order-md-2">
                <libero-dip-picker
                  [formName]="modelChartForm.controls['dip']"
                  [availableContracts]="availableContracts"
                  type="new-strategy"
                ></libero-dip-picker>
              </div>
            }
            <div class="col-12 col-md-6 order-md-2">
              <div class="filtration-label">
                {{ 'newPortfolio.filters.oneTimeDeposit' | translate }}
              </div>
              <libero-plus-minus-input
                [formName]="modelChartForm.controls['oneTimeDeposit']"
                [options]="{
                  step: 500,
                  displayUnits: getCurrencyFromCode(userService.loggedUser!.currencyCode),
                  minValue: !!editId && savedInvestmentParams?.initialDeposit ? savedInvestmentParams!.initialDeposit : configService.getConfig(EnvironmentKeys.minimalInvest),
                  maxValue: configService.getConfig(EnvironmentKeys.maximalInitialInvest),
                  allowZero: !editId || savedInvestmentParams?.initialDeposit === 0 ? configService.getConfig(EnvironmentKeys.allowZeroInitialDeposit) : false
                }"
                [digitShortcutsOptions]="digitShortcutsOptions"
                [invalidClass]="bothInvestmentsZero"
                [autoSetMinIfLower]="true"
                [minusBtnTestId]="'strategy-initial-deposit'"
                [disabled]="editingEfektika"
                [efektikaEditingMode]="editingEfektika"
                #efektikaNonEditEl
              ></libero-plus-minus-input>
            </div>
            <div class="col-12 col-md-6 order-md-3">
              <div class="filtration-label">
                {{ 'newPortfolio.filters.regularDeposit' | translate }}
              </div>
              <libero-plus-minus-input
                [formName]="modelChartForm.controls['regularDeposit']"
                [options]="{
                  step: 500,
                  displayUnits: getCurrencyFromCode(userService.loggedUser!.currencyCode),
                  minValue: !!editId && savedInvestmentParams?.regularDeposit ? savedInvestmentParams!.regularDeposit : configService.getConfig(EnvironmentKeys.minimalInvest),
                  maxValue: configService.getConfig(EnvironmentKeys.maximalRegularInvest),
                  allowZero: !editId || savedInvestmentParams?.regularDeposit === 0 ? configService.getConfig(EnvironmentKeys.allowZeroRegularDeposit) : false
                }"
                [digitShortcutsOptions]="digitShortcutsOptions"
                [invalidClass]="bothInvestmentsZero"
                data-cy="regular-deposit-input"
                [autoSetMinIfLower]="true"
                [minusBtnTestId]="'strategy-regular-deposit'"
                [disabled]="editingEfektika"
                [efektikaEditingMode]="editingEfektika"
                #efektikaNonEditEl
              ></libero-plus-minus-input>
              <div class="regularity-radios-container">
                <libero-radio-input-group
                  [availableValues]="availableInvestmentPeriods"
                  [formName]="modelChartForm.controls['depositRegularity']"
                  [cyId]="'strategy-investment-frequency'"
                  [disabled]="editingEfektika"
                  #efektikaNonEditEl
                ></libero-radio-input-group>
              </div>

              @if (dipAvailable && modelChartForm.value.dip.dip) {
                <div class="dip-disclaimer">
                  {{ 'newPortfolio.dipDisclaimer' | translate }}
                </div>
              }
            </div>
            <div class="col-12 col-md-6 order-md-4">
              <div class="filtration-label filtration-label--tooltiped">
                {{ 'newPortfolio.filters.timeOfInvestment' | translate }}
                <libero-tooltip-button [explainPerson]="'jiri_mikes'">
                  {{ 'global.tooltips.timeOfInvestment' | translate }}
                </libero-tooltip-button>
              </div>
              <!-- fixme - displayUnits -->
              <libero-plus-minus-input
                [formName]="modelChartForm.controls['timeOfInvestment']"
                [options]="{
                  step: 1,
                  minValue: !!editId && savedInvestmentParams?.totalYearsToInvest ? savedInvestmentParams!.totalYearsToInvest : 1,
                  maxValue: maxInvestmentLength,
                  sliderStartAtLowestStep: true,
                }"
                [digitShortcutsOptions]="yearsShortcutsOptions"
                [autoSetMinIfLower]="true"
                [minusBtnTestId]="'strategy-total-years-to-invest'"
                [disabled]="editingEfektika"
                [efektikaEditingMode]="editingEfektika"
                #efektikaNonEditEl
              ></libero-plus-minus-input>
            </div>
            <div class="col-12 col-md-6 order-md-5">
              <div class="filtration-label filtration-label--tooltiped">
                {{ 'newPortfolio.filters.rebalancing' | translate }}
                <libero-tooltip-button>
                  {{ 'global.tooltips.rebalancing' | translate }}
                </libero-tooltip-button>
              </div>
              <div
                #tooltipDisabledRebalancingByEstateHoverable
                class="rebalancing-switch-container"
                (click)="!rebalancingSwitchDisabled && rebalancingSwitched()"
                [ngClass]="{'--not-allowed': rebalancingSwitchDisabled}"
                data-cy="rebalancing-switch-container"
                tabindex="0"
                (keydown.enter)="!rebalancingSwitchDisabled && rebalancingSwitched()"
                (keydown.space)="!rebalancingSwitchDisabled && rebalancingSwitched()"
                >
                <div class="button-readonly-container">
                  <libero-toggle-switch [formName]="modelChartForm.controls['rebalancing']" [disabled]="rebalancingSwitchDisabled"></libero-toggle-switch>
                </div>
              </div>
              <div #tooltipDisabledRebalancingByEstateEl style="display: none;">
                @if (rebalancingSwitchDisabled) {
                  <div class="tooltip-content" data-cy="disabled-rebalancing-real-estate">
                    {{ 'strategies.realEstateDisabledRebalancingTooltip' | translate }}
                  </div>
                }
              </div>
            </div>
            @if (!entryFeeCalcService.requestStatus.error) {
              @if (entryFeeToDisplay || entryFeeCalcService.requestStatus.preloader) {
                <div
                  class="col-12 col-md-6 offset-md-3 order-md-last"
                  @fadeInOut
                  >
                  <div class="filtration-label filtration-label--tooltiped filtration-label--no-margin-bottom">
                    <libero-entry-fee-calc
                      [entryFeeToDisplay]="entryFeeToDisplay"
                      [currencyCode]="userService.loggedUser?.currencyCode ?? 'CZK'"
                      [loading]="entryFeeCalcService.requestStatus.preloader"
                      [useStrategyStyling]="true"
                    ></libero-entry-fee-calc>
                  </div>
                </div>
              }
            } @else {
              <div class="fees-api-error-container">
                {{ 'global.error.entryFeeLoadError' | translate }}
              </div>
            }
          </div>
        }
        <div class="development-chart-container">
          <div class="development-chart-header">
            <h2 class="form-header form-header--nogap">{{ 'newPortfolio.investmentDevelopmentModel' | translate }}</h2>
            <libero-tooltip-button>
              {{ 'global.tooltips.investmentDevelopmentModel' | translate }}
            </libero-tooltip-button>
          </div>

          @if (preloaders.modelChart) {
            <div class="model-chart-preload-container">
              <libero-preload-spinner></libero-preload-spinner>
            </div>
          } @else if(apiErrors.modelChart) {
            <div class="development-chart-error">
              {{ 'global.error.loadData' | translate }}
            </div>
          } @else if(apiErrors.insufficentModelChartWeights) {
            <div class="development-chart-error">
              {{ 'strategies.checksumNot100' | translate }}
            </div>
          } @else {
            <libero-development-chart [chartData]="developmentChartData" [xLabels]="developmentChartLabels"></libero-development-chart>
          }
        </div>
        <div class="consult-btn-container">
          <libero-button label="{{ 'global.buttons.consultation' | translate }}" (click)="modalService.openConsultModal();" btnClasses="btn--icon-text icon--secondary" svgIcon="accountant"></libero-button>
        </div>
        @if (!editId) {
          <div class="create-button-container">
            <libero-button [preloader]="preloaders.postingStrategy" label="{{ 'strategies.buttonCreateLabel' | translate }}" btnClasses="btn--primary btn--heading" (click)="createStrategy()" data-cy="create-strategy-button"></libero-button>
          </div>
        }
      </div>
      @if (editId) {
        <div class="edit-buttons-container">
          <libero-button
            [preloader]="preloaders.editStrategy"
            (click)="updateStrategy()"
            label="{{ 'global.buttons.saveChanges' | translate }}"
            btnClasses="btn--primary btn--heading"
            data-cy="edit-strategy-btn"
          ></libero-button>
          <libero-button
            [preloader]="preloaders.editStrategy"
            (click)="discardChanges()"
            label="{{ 'global.buttons.discardChanges' | translate }}"
            btnClasses="btn--secondary btn--heading"
          ></libero-button>
        </div>
      }
    </div>
  }
  <div #tooltipEfektikaEl style="display: none;">
    <div class="efektika-params-tooltip-content" data-cy="edit-strategy-efektika-tooltip">
      <div class="tooltip-text"> {{ 'global.tooltips.efektikaCannotEditParams' | translate }} </div>
    </div>
  </div>
</div>
